<template>
  <v-container>
    <v-row>
      <v-col sm="12" md="8">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">
              Login
            </h2>

            <form @submit.prevent="login">
              <h2>Login</h2>
              <input type="email" v-model="email" placeholder="Email address..." />
              <input type="password" v-model="password" placeholder="password..." />
              <button>Login</button>
            </form>

            <amplify-authenticator username-alias="email">
              <amplify-sign-up slot="sign-up" username-alias="email" :form-fields.prop="formFields"></amplify-sign-up>
              <amplify-sign-in slot="sign-in" username-alias="email"></amplify-sign-in>
            </amplify-authenticator>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Auth } from "aws-amplify";
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      formFields: [
        {
          type: "email",
          label: "Custom Email Label",
          placeholder: "Custom email placeholder",
          inputProps: { required: true, autocomplete: "username" },
        },
        {
          type: "password",
          label: "Custom Password Label",
          placeholder: "Custom password placeholder",
          inputProps: { required: true, autocomplete: "new-password" },
        },
        {
          type: "phone_number",
          label: "Custom Phone Label",
          placeholder: "Custom phone placeholder",
        },
      ],
    };
  },
  methods: {
    async login() {
      try {
        const user = await Auth.signIn(this.email, this.password);
        console.log("user", user);
        alert("Successfully logged in");
        this.$store.dispatch("login", user);
      } catch (error) {
        alert(error.message);
        console.log(error);
      }
    },
  },
};
</script>
